import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changePassword } from 'react-cognito';
import ProfileStyle from './ProfileSettingsPage.css';
import AWS from 'aws-sdk';
import MediaQuery from 'react-responsive';
import { Tabs, Tab, Row, Col, Button, FormGroup, FormControl, 
  ControlLabel, Image, Alert, Modal, Glyphicon,OverlayTrigger,Tooltip  } from 'react-bootstrap';

import axios from '../../../services/axios-service';
import * as actions from '../../../store/actions/index';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import CandidatePhoto from '../../../components/CandidatePhoto/CandidatePhoto';
import defaultImage from '../../../assets/images/camera.png';
import showIcon from '../../../assets/images/view.png';
import hideIcon from '../../../assets/images/hide.png';
import config from '../../../config';
import PropTypes from 'prop-types';
import FileUpload from '../../../hoc/FileUpload/FileUpload';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
import ToastNotification from '../../../components/UI/ToastNotification/ToastNotification';

/**
* @desc Show the Client Profile settings
* @version 1.0.1
* @author Amrutha KK , Lakshmikanth,Praveen George
*/
class ProfileSettings extends Component {
  state = {
    files: [],
    showModal: "",
    filesToBeSent: [],
    fileUploadCompleted : 0,
    filesPreview: [],
    filesCount: 0,
    fileUploadOpen: false,
    oldPassword: '',
    newPassword: '',
    rePassword: '',
    oldPasswordView:false,
    newPasswordView:false,
    rePasswordView:false,
    error: '',
    message:'',
    file: null,
    fileUploadError: '',
    errorMessage: null,
    errorPosition:'',
    imageDiv: null,
    profileImage: (this.props.userImageSignedUrl) ? (this.props.userImageSignedUrl) : defaultImage,
    isClient: (this.props.groups.includes('client')) ? true : false,isShowToast: false,
    toastMessage: null,
    toastVariant: null,
    toastId: null
  }
  dropzone;

  initCallback = (dropzone) => {
    this.dropzone = dropzone;
  }
/**
 * @desc Add file and validation in desktop
 * @param file, errorMessage
 * @return null
 */
  addFile = (file, errorMessage) => {  
    this.setState({ file: file, errorMessage: errorMessage });
  }
/**
 * @desc Add file and validation 
 * @param file
 * @return null
 */
  mobileAddFile = (file) => {
    this.setState({ fileUploadError: "" });
    this.onDrop(file);
  }
/**
 * @desc Delete file added
 * @param file
 * @return null
 */
  removeFile = (file) => {
    let files = [...this.state.files];
    const fileIndex = files.findIndex((file) => file === file);
    files.splice(fileIndex, 1);

    if(files.length > 0) {
      this.setState({ files: files, errorMessage: null });
    } else {
      this.setState({ file : null, errorMessage: null, files: [] });
    }
  }
  /**
 * @desc Redux call to get the client user details on first loading from store
 * @param null
 * @return null
 */
  componentDidMount() {
    this.props.onGetClientDetails(this.props.attributes['custom:userid'], false, this.props.user);
  }
 /**
 * @desc Save the reset password with validations
 * @param event
 * @return null
 */
  onSubmit = (event) => {
      const user = this.props.user;      
      event.preventDefault();     
      if(this.state.oldPassword.trim() =='' || this.state.newPassword.trim() =='' || this.state.rePassword.trim() =='') {
        let errorPosition = [];
        if(this.state.oldPassword.trim() ==''){
          errorPosition = errorPosition.concat('oldPassword');
        }
        if(this.state.newPassword.trim() ==''){
          errorPosition = errorPosition.concat('newPassword');
        }
        if (this.state.rePassword.trim() ==''){
          errorPosition = errorPosition.concat('reEnterPassword');
        }
        this.setState({
          errorPosition: errorPosition
        });
      } 
      else if(this.state.oldPassword !== this.state.newPassword && this.state.newPassword === this.state.rePassword ) {
      changePassword(user, this.state.oldPassword, this.state.newPassword)
        .then(() => this.setState({              
          oldPassword: '',
          newPassword: '',
          rePassword: '',
          error:'',
          errorPosition:'',     
          message: 'You have successfully updated your password ',
          isShowToast:true,
          toastMessage: 'Password updated successfully! ',
          toastVariant:'success',
          toastId: "tid" + (new Date()).getTime()  
        }))            
        .catch((err) => {
          ConsoleLog("err",this.state.errorPosition)
          let  errorPosition='';              
          if(err==='Incorrect username or password.'||
            err==="1 validation error detected: Value at 'previousPassword' failed to satisfy constraint: Member must have length greater than or equal to 6"||
            err==="1 validation error detected: Value at 'previousPassword' failed to satisfy constraint: Member must satisfy regular expression pattern: [\\S]+"){
            errorPosition = 'oldPassword';
            this.setState({ error:'Old password is incorrect, please try again ',errorPosition:errorPosition,message:''});
          }
          else if(err==="1 validation error detected: Value at 'proposedPassword' failed to satisfy constraint: Member must have length greater than or equal to 6"||
            err==='Password did not conform with policy: Password must have symbol characters'||
            err==='Password did not conform with policy: Password must have symbol characters'||
            err==='Password did not conform with policy: Password not long enough'||
            err==='Password did not conform with policy: Password must have numeric characters'||
            err==='Password did not conform with policy: Password must have uppercase characters'||
            err==="2 validation errors detected: Value at 'previousPassword' failed to satisfy constraint: Member must satisfy regular expression pattern: [\\S]+; Value at 'previousPassword' failed to satisfy constraint: Member must have length greater than or equal to 6"||
            err==="1 validation error detected: Value at 'proposedPassword' failed to satisfy constraint: Member must satisfy regular expression pattern: [\\S]+") {
            errorPosition = 'newPassword';
            this.setState({ error:'Minimum password length is 8 characters. One uppercase, lowercase, number and a special character is required ',errorPosition:errorPosition}); 
          }
          else{
            errorPosition = 'oldPassword';
            this.setState({ error:err,errorPosition:errorPosition,message:'' });
          }              
        });
      }
      else if(this.state.oldPassword === this.state.newPassword){
        let  errorPosition=''; 
        errorPosition = 'newPassword';
        this.setState({error:'This is the last password you used, please create a new one',errorPosition:errorPosition,message:''});
      }
      else{
        let  errorPosition=''; 
        errorPosition = 'reEnterPassword';
        this.setState({error:'Passwords do not match, Please try again ',errorPosition:errorPosition,message:''});      
      }  
    }
    /** function for onChange password start */
    /**
   * @desc Field to change OldPassword 
   * @param event
   * @return null
   */
    changeOldPassword = (event) => {
      this.setState({ oldPassword: event.target.value,error:'' });
    }
    /**
   * @desc Field to set NewPassword 
   * @param event
   * @return null
   */
    changeNewPassword = (event) => {
      this.setState({ newPassword: event.target.value,error:''});
    }
     /**
   * @desc Field to Reenter NewPassword 
   * @param event
   * @return null
   */
    changeRePassword = (event) => {
      this.setState({ rePassword: event.target.value ,error:''});
    }
    /** function for onChange password End */

    /** function for Show/Hide password start */
     /**
   * @desc Show/Hide Password field
   * @param null
   * @return null
   */
    oldPasswordView=()=>{
        this.setState({oldPasswordView:!this.state.oldPasswordView});
    }
    newPasswordView=()=>{
        this.setState({newPasswordView:!this.state.newPasswordView}); 
    }
    rePasswordView=()=>{
        this.setState({rePasswordView:!this.state.rePasswordView});  
    }
    /** function for Show/Hide password End */
  
  /**
   * @desc Drop externel file - Drag and adrop
   * @param file
   * @return null
   */
  onDrop = (file) => {   
    if(file === null) {
      this.setState({ errorMessage: "Please add an image" });
    } else {
      this.uploadFile(file, 'profilePhoto/' + this.props.attributes['custom:userid'] + '/' + file.name)
      .then((data)=> {
        const userData = {
          firstName: this.props.clientDetails.user_fname,
          lastName: this.props.clientDetails.user_lname,
          email: this.props.clientDetails.user_email,
          imgUrl: data.Key,
          userCompanyId: this.props.clientDetails.user_company_id,
          userBhId:this.props.clientDetails.user_bh_id,
          userType: this.props.clientDetails.user_role,
          location: this.props.clientDetails.user_location         
        }
        //consoleLog(userData)
        axios.post("/galaxy/user/" + this.props.clientDetails.user_id, JSON.stringify(userData))
          .then(
          (response) => {
            if(response.data.message === "success") {
              this.props.onUpdateProfileImage(userData.imgUrl, this.props.user);
            }
            this.setState({ showModal: false,
              isShowToast: true,
              toastMessage: 'Profile image uploaded successfully!',
              toastVariant: 'success', 
              toastId: "tid" + (new Date()).getTime() 
             });
              
          })
          .catch((err) => { this.setState({ showModal: false}); 
          ConsoleLog("error",err);
        }); 
      },
      (err) => { 
        this.setState({ showModal: false});
      });  
      this.setState({ fileUploadOpen: false,
                     errorMessage: null});
    }    
    
  }
    /**
   * @desc Update image succesfull pop-up
   * @param file
   * @return null
   */
  imageUpdateModal = () => {
    this.setState({ showModal: true, errorMessage: null });
  }

  close = () => {
      this.setState({ showModal: false, status: "" });
  }

  /**
  * @desc uploades files to S3 bucket and sets files to be sent in state
  * @param file, filePath
  * @return null
  */
  uploadFile = (file, filePath) => {
      AWS.config.update({
        region : config.cognito.region
      });
      
      let logins = {}
      logins['cognito-idp.'+ config.cognito.region +'.amazonaws.com/' + config.cognito.userPool] = this.props.user.storage['CognitoIdentityServiceProvider.'+ config.cognito.clientId +'.' + this.props.attributes.email + '.idToken'];
      // Add the User's Id Token to the Cognito credentials login map.
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: config.cognito.identityPool,
          Logins: logins
      });
            
      let S3 = new AWS.S3({ params: { Bucket: config.cognito.bucketName }});
      // Specify the S3 upload parameters
      let params = {
        Key: filePath,
        ContentType: file.type,
        Body: file,
        // ACL: 'public-read'
      };

      return new Promise(function(resolve, reject) {
        S3.upload(params, function(err, data) {
            if (err) {
                reject(err);
            } else {              
               resolve(data);
            }
        });
      });
  }

  selectFile = (e) => {
    this.input.click(e);
  }

  handleFileSelect = (e) => {
    let files = e.target.files || e.dataTransfer.files;   
    let file = (files.length > 0 && files[0]) ? files[0] : null;
    let fileUploadError = "";
    if(file && (file.size > (1024*1024))) {
      file = null;
      fileUploadError = "File size exceeded.";
    } else {      
      this.onDrop(file);
    }
    this.setState({ fileUploadError : fileUploadError });
  }
   /**
   * @desc cloase toast notification
   * @param null
   * @return null
   */
  handleCloseToastNotification = () => {
    this.setState({
      isShowToast: false,
      toastMessage: null,
      toastVariant: null
    })
  }
  /**
   * @desc Update Profile image for specific client 
   * @param prevProps
   * @return null
   */
  componentDidUpdate(prevProps) {
    if(this.props.userImageSignedUrl !== prevProps.userImageSignedUrl ) {
      this.setState({ profileImage: this.props.userImageSignedUrl }); 
    }
  }

  render() {
    const clientDetails = { ...this.props.clientDetails };
    let imageModal="";
    if (Object.keys(clientDetails).length === 0) {
        return (null);
    }
    if(this.state.showModal) {
      imageModal =  (
        <Modal id="client-image-modal" show={this.state.showModal} onHide={this.close} bsSize="large">
          <Modal.Header closeButton>
            <h2 className="client-image-modal-header">Upload Photo</h2>
          </Modal.Header>
          <Modal.Body>
            <section>
              <div>
                <FileUpload multiple={false} 
                  name='profile-image-upload'
                  maxSize={1000*1000}
                  acceptedTypes="image/*"
                  handleFileSelect={this.addFile} />
              </div>
              <div className="client-upload-photo-div">
                <div className="imageAlert">
                  {(this.state.errorMessage) ? <span className="error-message">{this.state.errorMessage} </span>:""}
                  
                  <Button className="client-upload-photo-button" onClick={() => this.onDrop(this.state.file)}>
                    Upload Photo
                  </Button>
                </div>                              
              </div> 
            </section>
          </Modal.Body>
        </Modal>
      );
    }

    const initials = ""; //(clientDetails.user_firstname).charAt(0) + '' + (clientDetails.user_lastname).charAt(0);
    const photoClassName = (clientDetails.user_image_url) ? "client-photo client-attach-Photo" : "client-default-photo client-attach-Photo";
    
    return (
      <div className="client-Profile-container">
        <div className="ClientProfileSection">
          <Tabs defaultActiveKey={1} id="uncontrolled-tab-example" className="profile-tabs">
            <Tab eventKey={1} title="My Profile">
              <div className="client-profile-settings">
                {/* client photo and basic info section starts */}         
                <div className="row">
                  <div className="col-md-2 profile-image">
                    <MediaQuery query="(max-device-width: 769px)">                                           
                      <div className={photoClassName} onClick={this.selectFile} >
                        <CandidatePhoto initials={null} candidatePhoto={this.state.profileImage} isS3Url={true}/>
                        <input type='file'
                          tabIndex='-1'
                          ref={x => this.input = x}
                          className="input-file-upload"
                          name='profile-image-upload'
                          multiple={false}
                          size={1000*1000}
                          accept="image/*"
                          onChange={this.handleFileSelect}/>
                      </div>                      
                      { (this.state.fileUploadError !== "") ? <span className="error-message">{ this.state.fileUploadError }</span> : "" }
                    </MediaQuery>
                    <MediaQuery query="(min-device-width: 768px)">                                            
                      <div className={photoClassName} onClick={() => this.imageUpdateModal()}>
                        <CandidatePhoto initials={null} candidatePhoto={this.state.profileImage} isS3Url={true}/>
                      </div>
                    </MediaQuery>                                      
                  </div>                                
                  <div className="col-md-10 profile-summary">
                    <h1 className="user-name">
                      {clientDetails.user_fname} {clientDetails.user_lname}
                    </h1>
                    <p className="user-mail">{clientDetails.user_email}</p>                                      
                  </div>
                </div>
                <div className="line"></div>
                {/* password update section starts */}
                <div className="row">                                  
                  <form onSubmit={this.onSubmit}>
                    <div className="form col-md-3 col-xs-12">  
                      <ControlLabel>Enter Old Password</ControlLabel>                                    
                      <FormControl 
                        id="formOldPassword"
                        type={(!this.state.oldPasswordView) ? "password" : "text"}
                        helpertext="Please enter your old password"
                        placeholder="Enter Old Password"
                        onChange={this.changeOldPassword}
                        className={(this.state.oldPassword.trim() =='' 
                          && this.state.errorPosition.includes("oldPassword")) ?
                          "invalid" :(this.state.error && this.state.errorPosition =="oldPassword")? "invalid" : ""}
                        margin="normal"
                        value={this.state.oldPassword}
                      />                                                          
                      <span className="form-control-feedback" onClick={() => this.oldPasswordView() }>{this.state.oldPasswordView?<img className="hide-icon" src={hideIcon}/>:<img className="view-icon" src={showIcon}/>}</span>
                      <p className="error-message">
                        {(this.state.oldPassword.trim() =='' && this.state.errorPosition.includes("oldPassword")) ?
                        "Please enter old password" :(this.state.error && this.state.errorPosition =="oldPassword")? this.state.error : null}
                      </p> 
                    </div>

                    <div className="form col-md-3 col-xs-12">
                      <ControlLabel>Enter New Password</ControlLabel>  
                      <FormControl                        
                        id="formNewPassword"
                        type={(!this.state.newPasswordView) ? "password" : "text"}
                        helpertext="Please enter your new password"
                        placeholder="Enter New Password"
                        onChange={this.changeNewPassword}
                        className={(this.state.newPassword.trim() =='' 
                          && this.state.errorPosition.includes("newPassword")) ?
                          "invalid" :(this.state.error && this.state.errorPosition =="newPassword")? "invalid" : ""}
                        value={this.state.newPassword}
                        margin="normal"
                      />                       
                      <span className="form-control-feedback"onClick={()=>this.newPasswordView()}>{this.state.newPasswordView?<img className="hide-icon" src={hideIcon}/>:<img className="view-icon" src={showIcon}/>}</span>   
                      <p className="error-message">
                        {(this.state.newPassword.trim() =='' && this.state.errorPosition.includes("newPassword")) ? 
                        "Please enter new password" :(this.state.error && this.state.errorPosition =="newPassword")? this.state.error : null}
                      </p>
                    </div>

                    <div className="form col-md-3 col-xs-12">  
                      <ControlLabel>Re-enter New Password</ControlLabel>                                        
                      <FormControl
                        id="formConfirmPassword"
                        type={(!this.state.rePasswordView) ? "password" : "text"}
                        helpertext="Please Re-enter New  password"
                        placeholder="Re-enter New Password"                        
                        onChange={this.changeRePassword}
                        className={(this.state.rePassword.trim() =='' 
                          && this.state.errorPosition.includes("reEnterPassword")) ?
                          "invalid" :(this.state.error && this.state.errorPosition =="reEnterPassword")? "invalid" : ""}
                        value={this.state.rePassword}
                        margin="normal"
                      />
                      <p className="error-message">
                       {(this.state.rePassword.trim() =='' && this.state.errorPosition.includes("reEnterPassword")) ? 
                          "Please re-enter new password " :(this.state.error &&  this.state.errorPosition =="reEnterPassword")? this.state.error : null}
                      </p>
                      
                      <span className="form-control-feedback"onClick={()=>this.rePasswordView()}>{this.state.rePasswordView?<img className="hide-icon" src={hideIcon}/>:<img className="view-icon" src={showIcon}/>}</span>
                    </div>
                    
                    <div className="col-md-2 col-xs-12 button-container">
                      <Button type="submit" className="btn updatepwd" variant="raised" color="default">Update Password</Button>
                      { (this.state.message) ? 
                        <p className="success-message">{(this.state.error)?null:null}</p> 
                      :null}
                    </div>                    
                    
                  </form>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
        <div className="ClientCompanySection">
          <Tabs defaultActiveKey={1} id="uncontrolled-tab-example" className="profile-tabs">
            <Tab eventKey={1} title="Company Information">
              <div className="client-profile-settings">
                <div className="col-md-12">
                  <div className="row">
                    <div className="info-box col-md-4">
                      <h2 className="user-info">Company Name</h2>
                      <p className="user-info ">{this.props.clientDetails.company_name}</p>
                    </div>
                    <div className="info-box col-md-4">
                      <h2 className="user-info">Address</h2>
                      <p className="user-info ">{this.props.clientDetails.company_address}</p>
                    </div>
                    <div className="info-box ib3 col-md-4">
                      <h2 className="user-info">
                      {(this.props.clientDetails.user_role === 2 || this.props.clientDetails.user_role === 4) ? "Primary Contact" : "Admin Contact"}
                      </h2>
                      <p className="user-info ">
                        {this.props.clientDetails.primary_contact_name}<br/>
                        {this.props.clientDetails.primary_contact_email}<br/>
                        {this.props.clientDetails.primary_contact_phone_number}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
        {imageModal }
        <ToastNotification 
            isShowToast={this.state.isShowToast} 
            message={this.state.toastMessage} 
            variant={this.state.toastVariant} 
            onClose={this.handleCloseToastNotification}
            toastId={this.state.toastId}
          />
      </div>
    );
  }
}
/**
* @desc connecting to redux store
* @param state
* @return redux state
*/
const mapStateToProps = state => {
    return {
        user: state.cognito.user,
        attributes: state.cognito.attributes,
        clientDetails: state.clientProfile.clientDetails,
        groups: state.cognito.groups,
        userImageSignedUrl: state.clientProfile.userImageSignedUrl
    };
}
/**
* @desc connecting to redux actions
* @param dispatch
* @return redux actions
*/
const mapDispatchToProps = dispatch => {
    return {
      onGetClientDetails: (clientId, isJobList, loggedInUser) => dispatch(actions.getClientDetails(clientId, isJobList, loggedInUser)),
      onUpdateProfileImage: (userImageUrl, loggedInUser) => dispatch(actions.getProfileImage(userImageUrl, loggedInUser))
    }
}

ProfileSettings.propTypes = {
  onSubmit: PropTypes.func,
  store: PropTypes.object,
  error: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(ProfileSettings,axios));



// WEBPACK FOOTER //
// ./src/components/Common/ProfileSettingsPage/ProfileSettingsPage.js